export const Orientation = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  AUTO: 'auto',
};

export default {
  Orientation,
};
